module.exports = __webpack_public_path__ + "assets/img/IMG012.58d81609.png";